import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductManagement/configurationList',
        method: 'post',
        data: {
            ...params,
            current,
            size
        }
    })
}

export const openOrForbidden = (data) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductManagement/openOrForbidden',
        method: 'post',
        data
    })
}

// 获取产品设置列表
export const findProduct = (data) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductManagement/find-product',
        method: 'post',
        data
    })
}

// 代理商绑定产品
export const loanProductManagementBind = (data) => {
  return request({
    url: '/api/blade-loanProductManagement/loanProductManagement/bind',
    method: 'post',
    data
  })
}

// 代理商绑定产品
export const loanProductManagementUnbind = (data) => {
  return request({
    url: '/api/blade-loanProductManagement/loanProductManagement/unbind',
    method: 'post',
    data
  })
}

// 查询产品对应的租期，租付类型
export const findProductInfo = (data) => {
  return request({
    url: `/api/blade-loanProductManagement/loanProductManagement/findProductInfo?productId=${data}`,
    method: 'post',
  })
}

// 查询产品对应的租期，租付类型
export const findProductRate = (data) => {
  return request({
    url: '/api/blade-loanProductManagement/loanProductManagement/findProductRate',
    method: 'post',
    data
  })
}